var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visibility)?_c('v-icon',{attrs:{"size":"30","color":_vm.value ? 'kDartessGreen' : 'kDartessRed'}},[_vm._v(" "+_vm._s(_vm.value ? "mdi-check-circle" : "mdi-close-circle")+" ")]):_c('span',{staticClass:"pa-0 ma-0"},[_vm._v("-")])}
var staticRenderFns = []

export { render, staticRenderFns }